import { useStore, ActionTypes } from "../store"; 
import instance from './index'; 
import ExceptionHandling from './ExceptionHandling.js';

export default class EReceiptService {
 
  static fetchReceiptById(receiptId) {

    const api = `/api/fetch_receipt_by_id`; 
    const store = useStore(); // Access the store to show/hide progress bar
    store.dispatch(ActionTypes.PROGRESS_BAR, true); 

    const formData = new FormData(); 
    formData.append('receiptId', receiptId); // Append the receiptId to FormData

    return instance()({
      method: 'post',
      url: api,
      data: formData, // Send FormData containing receiptId
    })
      .then(response => {
        return response.data; // Return response data if request is successful
      })
      .catch(error => {
        ExceptionHandling.HandleErrors(error); // Handle any errors
        throw error; 
      })
      .finally(() => {
        store.dispatch(ActionTypes.PROGRESS_BAR, false); 
      });
  }
}
